import React from 'react';
import Helmet from 'react-helmet';
import { BreadCrumbs } from '../components/BreadCrumbs';
import { DriversSection } from '../components/DriversSection';
import { Text } from '../components/Text';
import { domainNProto, headings } from '../data';

const DriversRoute = () => (
  <>
    <Helmet title='Драйверы и программы для принтеров этикеток, принтеров чеков'>
      <meta property='og:type' content='website' />
      <meta property='og:title' content={headings['/support/software']} />
      <meta property='og:url' content={`${domainNProto}/support/software`} />
      <meta
        property='og:description'
        content={
          'Программное обеспечение и драйверы для для принтеров этикеток, '
            + 'принтеров чеков и другого оборудования на Posprinters.ru'
        }
      />
    </Helmet>
    <BreadCrumbs crumbs={[['/support'], ['/support/software']]} />
    <Text type='h1'>{headings['/support/software']}</Text>
    <DriversSection />
  </>
);

export default DriversRoute;
